// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// The products hash maps the domain component (aka creditrepair) -> product family

export const environment = {
  production: false,
  apiGateway: {
    invokeUrl: "https://wi44k83fol.execute-api.us-east-1.amazonaws.com/stg",
  },
  config: {
    lang: "en-us",
    products: {
      creditblock: "Credit Block",
      creditdevelopment: "Credit Development",
      creditrepair: "Credit Repair",
      creditrepairwithdevelopment: "Credit Dev with Premium Credit Repair",
      creditreport: "Credit Report",
      cybersweep: "Cyber Sweep",
    },
    productRequiresDemographicInfo: [
      "creditdevelopment",
      "creditrepairwithdevelopment",
    ],
    productHasCreditBlockUpsell: [
      "creditdevelopment",
      "creditrepairwithdevelopment",
      "creditrepair",
      "cybersweep",
    ],
    productHasChexSystemUpsell: [],
    creditBlockUpsellNeedsSSN: ["cybersweep"],
    companyPhone: "1-833-820-0126",
    displayPartnerLogo: {
      R6F3IXRL76SWKKC48EQ1HX9L7VGIZB6BL61L:
        "/assets/imgs/partners/pmcm_logo.png",
    },
    timeout: 3500,
  },
};
